import React from 'react';
interface PillProps {
  children: React.ReactNode;
  tone?: 'gold' | 'rose';
  className?: string;
}
export function Pill({
  children,
  tone = 'gold',
  className = ''
}: PillProps) {
  const tones = tone === 'gold' ? 'border-gold/50 bg-cream text-goldink' : 'border-rose-deep/40 bg-rose-light/60 text-wine';
  return <span className={`inline-flex items-center rounded-full border px-4 py-1.5 font-sans text-[11px] font-semibold uppercase tracking-[0.18em] ${tones} ${className}`} data-id="element-185" data-mp="n7aqqxxbtg0q">
      {children}
    </span>;
}